import { enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { firestore } from './firebaseConfig';

export const enableFirestoreCache = async () => {
    try {
        await enableMultiTabIndexedDbPersistence(firestore);
    } catch (error) {
        if (error?.code !== 'failed-precondition' && error?.code !== 'unimplemented') {
            console.warn('Firestore persistent cache could not be enabled:', error);
        }
    }
};
